<script setup>
import dayjs from "dayjs";
import useUserStore from "@/store/userStore.js";
const userStore = useUserStore();

function getTimePeriod() {
  const hour = dayjs().hour();
  if (hour >= 0 && hour < 6) {
    return "凌晨";
  } else if (hour >= 6 && hour < 12) {
    return "上午";
  } else if (hour >= 12 && hour < 18) {
    return "下午";
  } else {
    return "晚上";
  }
}
</script>

<template>
  <div>
    <a-card>
      <div style="font-size: 24px">
        {{ userStore.state.realName }}，{{ getTimePeriod() }}好！
      </div>
    </a-card>
  </div>
</template>

<style scoped lang="scss"></style>
